<app-navbar></app-navbar>
<button (click)="toggleChat(true)" class="btn-nativ scroll-btn chat-btn"><img
    src="../../../assets/images/chat/chat_icon.png" /></button>
<div *ngIf="isShowChat">
  <app-chat-inbox [isShow]="isShowChat" (isShowChatEvent)="toggleChat($event)"></app-chat-inbox>
</div>
<div class="app-body" (window:resize)="onResize()">
  <router-outlet></router-outlet>
</div>